// extracted by mini-css-extract-plugin
module.exports = {"garden":"garden","living":"living","wedding":"wedding","shadow":"review-view_shadow__1er6o","wrapper":"review-view_wrapper__3C3xD","reply":"review-view_reply__26Jlw"};